import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeHouseholdSetupDataAccessStoreModule } from '@se-po/se-household-setup-data-access-store'
import { SharedFeatureHouseholdReviewModule } from '@se-po/shared-feature-household-review'
import { SharedUiSetupBarModule } from '@se-po/shared-ui-setup-bar'
import { ReviewComponent } from './review/review.component'

@NgModule({
  imports: [
    CommonModule,
    SeHouseholdSetupDataAccessStoreModule,
    SharedFeatureHouseholdReviewModule,
    SharedUiSetupBarModule,
  ],
  declarations: [ReviewComponent],
  exports: [ReviewComponent],
})
export class SeHouseholdSetupFeatureReviewModule {}
